<template>
    <rkm-overlay>
        <rkm-layout-body title="Pré-agendar transporte">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="hasPermissaoAtualizacaoCadastroPaciente"
                    @click="handleBuscarDadosPacienteIntegracaoCns"
                    color="info"
                >
                    Buscar dados do paciente no CADSUS
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    :key="formKey"
                    @add="formKey++"
                    @handleAtualizaPaciente="handleAtualizaPaciente"
                    @handleExitPaciente="handleExitPaciente"
                    @loaded="loaded"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>

            <ModalIntegracaoCns
                @update="handleIntegracaoCnsUpdate"
                ref="ModalIntegracaoCns"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/transporte-paciente/pre-agendamento-transporte/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import {unmask} from '@/mixins'

import { mapActions } from 'vuex';

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.form && this.form.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.setShowExitFormConfirmation()
    },
    data: () => ({
        additionals: null,
        enums: {classificacao},
        form: null,
        formKey: 1,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation'
        ]),
        loaded(value) {
            this.additionals = value.additionals
            this.form = value.form

            if (this.additionals.enderecoDesatualizadoBloqueado) {

                this.unsetShowExitFormConfirmation()

                this.showAlert(
                    'O endereço do paciente ainda não foi atualizado pela Base Nacional. Atualize o cadastro para continuar.',
                    'Atenção'
                )

                this.handleExit()
            }
        },
        handleExit() {
            this.$router.push({ name: 'pre-agendamento-transporte-index' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
        },
        handleExitPaciente() {

            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        handleAtualizaPaciente() {

            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'cadastro-paciente-edit', params: { id: this.id } })
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.form.paciente.cidadaoId,
                nome: this.form.paciente.nome,
                dataNascimento: this.form.paciente.dataNascimento,
                nomeMae: this.form.paciente.nomeMae,
                cns: this.form.paciente.cns ? this.unMaskCns(this.form.paciente.cns) : null,
                cpf: this.form.paciente.cpf ? this.unMaskCpf(this.form.paciente.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.form.paciente, {
                ...item,
                racaCorId: item.racaCor.id,
            })
        },
    },
    mixins: [unmask],
    props: {
        id: { type: Number, default: null }
    },
}
</script>